import { render, staticRenderFns } from "./farmersBind.vue?vue&type=template&id=563b6f28&scoped=true"
import script from "./farmersBind.vue?vue&type=script&lang=js"
export * from "./farmersBind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563b6f28",
  null
  
)

export default component.exports